const PERMISSONS_OTHER = {
    // 视频
    'VIDEO': 'video',
    // 接收协作任务
    'COOP_TASK': 'coopTask',
    // 创建报案
    'NEW_REPORT': 'newReport',
};
// 回访权限
const PERMISSONS_CLIENT_REVIEW = {
    // 回访任务
    CLIENT_REVIEW: 'CLIENT_REVIEW',
};

// 资料收集权限
const PERMISSIONS_COLLECT = {
    //  含人伤案件， 产品定义： 该权限包含了 有人伤的案件 和 没有任何 伤亡损失的案件都包含在内
    INJURY_CASE: 'INJURY_CASE',
    // 车物损案件
    CAR_DAMAGE_LOSS_CASE: 'CAR_DAMAGE_LOSS_CASE',
}

// 理赔权限
const PERMISSIONS_CLAIM = {
    //  含人伤案件， 产品定义： 该权限包含了 有人伤的案件 和 没有任何 伤亡损失的案件都包含在内
    INJURY_CASE: 'INJURY_CASE',
    // 车物损案件
    CAR_DAMAGE_LOSS_CASE: 'CAR_DAMAGE_LOSS_CASE',
    //  大案疑案
    MAHJOR_CASE: 'MAHJOR_CASE',
}

// 定损权限
const PERMISSIONS_DEFLOSS = {
    // 车物损案件
    CAR_DAMAGE_LOSS_CASE: 'CAR_DAMAGE_LOSS_CASE',
}

// 本地上传权限
const PERMISSIONS_LOCAL_UPLOAD = {
    // 自己案件
    OWN_CASE: 'OWN_CASE',
    // 同一机构案件
    SAME_ORG_CASE: 'SAME_ORG_CASE',
    // 不同机构案件
    DIFF_ORG_CASE: 'DIFF_ORG_CASE',
}

// 检查坐席有回访权限
const hasClientReviewPermission = (agent = {}) => {
    const { clientReviewPermission = [] } = agent;
    return clientReviewPermission.some((perm) => {
        return Object.keys(PERMISSONS_CLIENT_REVIEW).includes(perm);
    });
}
// 检查坐席是否有理赔权限
const hasClaimPermission = (agent = {}) => {
    const { claimPermission = [] } = agent;
    return claimPermission.some((perm) => {
        return Object.keys(PERMISSIONS_CLAIM).includes(perm);
    });
}
// 检查坐席是否有有定损权限
const hasDefLossPermission = (agent = {}) => {
    const { defLossPermission = [] } = agent;
    return defLossPermission.some((perm) => {
        return Object.keys(PERMISSIONS_DEFLOSS).includes(perm);
    });
}
// 检查案件是否有资料收集权限
const hasCollectorPermission = (agent = {}) => {
    const { collectPermission = [] } = agent;
    return collectPermission.some((perm) => {
        return Object.keys(PERMISSIONS_COLLECT).includes(perm);
    });
}
// 检查坐席是否有协作权限
const hasCoopTaskPermission = (agent = {}) => {
    const { permission = [] } = agent;
    return permission.includes(PERMISSONS_OTHER.COOP_TASK);
}
// 检查坐席是否有大案权限
const hasMajorCasePermission = (agent = {}) => {
    const { claimPermission = [] } = agent;
    return claimPermission.includes(PERMISSIONS_CLAIM.MAHJOR_CASE);
}
// 检查坐席是否有本地上传权限
const hasLocalUploadOwnCasePermission = (agent = {}) => {
    const { localUploadPermission = [] } = agent;
    return localUploadPermission.some(perm => Object.keys(PERMISSIONS_LOCAL_UPLOAD).includes(perm));
}
// 检查坐席是否有当前机构上传权限
const hasLocalUploadSameOrgPermission = (agent = {}) => {
    const { localUploadPermission = [] } = agent;
    return localUploadPermission.some(perm => [
        PERMISSIONS_LOCAL_UPLOAD.DIFF_ORG_CASE,
        PERMISSIONS_LOCAL_UPLOAD.SAME_ORG_CASE,
    ].includes(perm));
}
// 检查坐席是否有跨机构上传权限
const hasLocalUploadDiffOrgPermission = (agent = {}) => {
    const { localUploadPermission = [] } = agent;
    return localUploadPermission.some(perm => [
        PERMISSIONS_LOCAL_UPLOAD.DIFF_ORG_CASE,
    ].includes(perm));
}
// 检查是否需要显示本地上传按钮
const isShowLocalUploadButton = (report = {}, agent = {}) => {
    const { orgAccount, agentId, defLossTask = {} } = report;
    const reportOrgId = orgAccount && orgAccount._id ? orgAccount._id : orgAccount;
    const reportAgentId = agentId && agentId._id ? agentId._id : agentId;
    const defLossTaskAgentId = defLossTask.agentId && defLossTask.agentId._id ? defLossTask.agentId._id : defLossTask.agentId;
    const curAgentId = agent._id;
    const curAgentOrgAccoutId = agent.orgAccount && agent.orgAccount._id ? agent.orgAccount._id : agent.orgAccount;
    if (!curAgentId) return false;
    const isOwnCase = [reportAgentId, defLossTaskAgentId].includes(curAgentId);
    const isSameOrg = reportOrgId === curAgentOrgAccoutId;
    const isDiffOrg = reportOrgId !== curAgentOrgAccoutId

    if (isOwnCase && hasLocalUploadOwnCasePermission(agent)) return true;
    if (isSameOrg && hasLocalUploadSameOrgPermission(agent)) return true;
    if (isDiffOrg && hasLocalUploadDiffOrgPermission(agent)) return true;
    return false;
}

// 检查是否有创见报案权限
const hasCreateReportPermission = (agent = {}) => {
    const { permission = [] } = agent;
    return permission.includes(PERMISSONS_OTHER.NEW_REPORT);
}

// 检查是否有跨机构查询案件权限
const overOrgQueryReportsPermission = (agent = {}) => {
    const { orgAccount = {}, agentRole = {} } = agent;
    const { defLossPermissions = [] } = orgAccount || {};
    if (agentRole.level === '3') return true;
    return defLossPermissions.includes('overOrgQuery');
}

export {
    hasClientReviewPermission,
    hasClaimPermission,
    hasDefLossPermission,
    hasCollectorPermission,
    hasCoopTaskPermission,
    hasMajorCasePermission,
    isShowLocalUploadButton,
    hasCreateReportPermission,
    overOrgQueryReportsPermission
}